import React from "react";
import PropTypes from "prop-types";

const ErrorFallback = ({ error, resetErrorBoundary }) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundColor: "#f8f9fa",
        color: "#343a40",
        textAlign: "center",
      }}
    >
      {/* Navigation Bar */}
      <nav
        style={{
          width: "100%",
          backgroundColor: "#212529",
          color: "white",
          padding: "10px 20px",
          textAlign: "center",
          boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
          fontSize: "18px",
        }}
      >
        <strong>Oops! Something went wrong</strong>
      </nav>

      {/* Error Message */}
      <div>
        <h1 style={{ fontSize: "3rem", marginBottom: "20px" }}>We're down!</h1>
        <p style={{ fontSize: "1.2rem", marginBottom: "20px" }}>
          An unexpected error has occurred.
        </p>
        <pre
          style={{
            padding: "10px",
            backgroundColor: "#e9ecef",
            borderRadius: "5px",
            maxWidth: "80%",
            overflowX: "auto",
            textAlign: "left",
            color: "#495057",
          }}
        >
          {error.message}
        </pre>

        {/* Reset Button */}
        <button
          onClick={resetErrorBoundary}
          style={{
            padding: "10px 20px",
            backgroundColor: "#007bff",
            color: "white",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
            fontSize: "1rem",
          }}
        >
          Try Again
        </button>
      </div>
    </div>
  );
};

// ErrorFallback.propTypes = {
//   error: PropTypes.shape({
//     message: PropTypes.string,
//   }).isRequired,
//   resetErrorBoundary: PropTypes.func.isRequired,
// };
ErrorFallback.defaultProps = {
  error: { message: "An unknown error occurred." },
};

export default ErrorFallback;
